import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Additional Vuetify customization
import '@/assets/scss/app.scss'

import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    light: true,
    themes: {
      light: {
        // VeroFresh brand palette (Brand Guidelines v6.7): Teal 2 as primary,
        // with a ramp running down to Teal 1 (#044244) for dark surfaces (side nav, top bar).
        primary: '#195152',
        'primary-900': '#044244',
        'primary-800': '#0A4749',
        'primary-700': '#114C4E',
        'primary-600': '#144F50',

        // VeroFresh Lime 1, ramping down to darker limes and up to Lime 2 (#C3DC82).
        secondary: '#B8D539',
        'secondary-900': '#7C931F',
        'secondary-800': '#90A927',
        'secondary-700': '#A4BF30',
        'secondary-600': '#C3DC82',
        'secondary-500': '#D7E8AB',

        // VeroFresh Teal 4
        header: '#DBEDD5',

        anchor: '#195152',

        error: '#B33505',
        danger: '#B33505',
        success: '#30A216',
        warning: '#E09037',
        info: '#03A94F',
        'root-only': '#fff9ef',

        'temperature-hot': colors.red.darken1,
        'temperature-cold': colors.blue.lighten1,

        // These are darkened versions of the zone colors from the bootstrap app, maybe these work, maybe not.
        // Maybe we don't even use them anymore? Decision up for grabs.
        cooler: '#72a207',
        freezer: '#0b6293',

        // This is the color a lot of vuetify icons are rendered as. Normally it's a 0,0,0 with an opacity of .57,
        // however you apparently can't define rgba colors in here.
        'std-icon-grey': '#757575'
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi'
  }
}

export default new Vuetify(opts)
